import React, { useMemo, useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled, { css, createGlobalStyle } from "styled-components";
import useStore from "./store";
import fullscr_open from "./images/fullscreen_open.png";
import fullscr_exit from "./images/fullscreen_exit.png";

// var elem = document.getElementById("root");

// function openFullscreen() {
//   if (elem.requestFullscreen) {
//     elem.requestFullscreen();
//   } else if (elem.webkitRequestFullscreen) {
//     /* Safari */
//     elem.webkitRequestFullscreen();
//   } else if (elem.msRequestFullscreen) {
//     /* IE11 */
//     elem.msRequestFullscreen();
//   }
// }

export default function Hud() {
  const points = useStore((state) => state.points);
  const health = useStore((state) => state.health);
  const sound = useStore((state) => state.sound);
  const toggle = useStore((state) => state.actions.toggleSound);

  const [isFullscreen, setIsFullscreen] = useState(false);

  document.addEventListener('fullscreenchange', (event) => {
    if (document.fullscreenElement) {
      // We’re going fullscreen
      console.log("Fullscreen on");
    } else {
      // We’re exiting fullscreen
      console.log("Fullscreen off");
    }
  });

  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener('fullscreenchange', onFullscreenChange);

    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);

  const seconds = useRef();
  useEffect(() => {
    const t = Date.now();
    const i = setInterval(
      () => (seconds.current = ((Date.now() - t) / 1000).toFixed(1)),
      100
    );
    return () => clearInterval(i);
  }, []);

  const score = useMemo(
    () => (points >= 1000 ? (points / 1000).toFixed(1) + "K" : points),
    [points]
  );
  return (
    <>
      <UpperLeft onClick={() => toggle()}>
        sound
        <br />
        {!sound ? "off" : "on"}
      </UpperLeft>
      <UpperRight>
        <a href="https://codesandbox.io/s/react-three-fiber-untitled-game-4182v">
          source
        </a>
        <br />
        <a href="https://twitter.com/webmaeistro">Martin Andersen</a>
        <br />
        <a href="https://github.com/webmaeistro">github</a>
      </UpperRight>
      <LowerLeft>
        <h2 ref={seconds}>0.0</h2>
        <h1>{score}</h1>
      </LowerLeft>
      <Global />
      <LowerRight>
        <div style={{ width: health + "%" }} />
      </LowerRight>
      <LowerRightX
        onClick={() => {
          window.location = "/";
        }}
      >
        <div>Menu</div>
      </LowerRightX>
      <LowerRightY
        onClick={() => {
          if (!isFullscreen) {
            document.body.requestFullscreen();
          } else {
            document.exitFullscreen();
          }
        }}
      >
        <img src={!isFullscreen ? fullscr_open : fullscr_exit } height="23" size="23" title="fullscreen" alt="fullscreen"></img>
      </LowerRightY>
    </>
  );
}

const base = css`
  font-family: "Teko", sans-serif;
  position: absolute;
  text-transform: uppercase;
  font-weight: 900;
  font-variant-numeric: slashed-zero tabular-nums;
  line-height: 1em;
  pointer-events: none;
  color: lightgrey;
`;

const UpperLeft = styled.div`
  ${base}
  top: 40px;
  left: 50px;
  font-size: 2em;
  transform: skew(5deg, 10deg);
  pointer-events: all;
  cursor: pointer;
  @media only screen and (max-width: 900px) {
    font-size: 1.5em;
  }
`;

const UpperRight = styled.div`
  ${base}
  text-align: right;
  top: 40px;
  right: 50px;
  font-size: 2em;
  transform: skew(-5deg, -10deg);
  pointer-events: all;
  cursor: pointer;
  & > a {
    color: lightgrey;
    text-decoration: none;
  }
  @media only screen and (max-width: 900px) {
    font-size: 1.5em;
  }
`;

const LowerLeft = styled.div`
  ${base}
  bottom: 5px;
  left: 50px;
  transform: skew(-5deg, -10deg);
  width: 200px;
  & > h1 {
    margin: 0;
    font-size: 14em;
    line-height: 1em;
  }
  & > h2 {
    margin: 0;
    font-size: 4em;
    line-height: 1em;
  }
  @media only screen and (max-width: 900px) {
    bottom: 30px;
    & > h1 {
      font-size: 6em !important;
    }
    & > h2 {
      font-size: 3em !important;
    }
  }
`;

const LowerRight = styled.div`
  ${base}
  bottom: 70px;
  right: 50px;
  transform: skew(5deg, 10deg);
  height: 60px;
  width: 200px;
  background: black;
  & > div {
    height: 100%;
    background: lightgrey;
  }

  @media only screen and (max-width: 900px) {
    bottom: 50px;
    height: 40px;
    width: 150px;
  }
`;

const LowerRightX = styled.div`
  ${base}
  bottom: 40px;
  right: 180px;
  font-size: 2em;
  transform: skew(5deg, 10deg);
  pointer-events: all;
  cursor: pointer;
  @media only screen and (max-width: 900px) {
    font-size: 1.5em;
  }
  @media only screen and (max-width: 900px) {
    bottom: 10px;
    right: 42px;
    height: 40px;
    width: 150px;
  }
`;

const LowerRightY = styled.div`
  ${base}
  bottom: 30px;
  right: 140px;
  font-size: 2em;
  transform: skew(5deg, 10deg);
  pointer-events: all;
  cursor: pointer;
  @media only screen and (max-width: 900px) {
    font-size: 1.5em;
  }
  @media only screen and (max-width: 900px) {
    bottom: 3px;
    right: 0px;
    height: 40px;
    width: 150px;
  }
`;

const Global = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    user-select: none;
    overflow: hidden;
  }

  #root {
    overflow: auto;
    padding: 0px;
  }

  body {
    position: fixed;
    overflow: hidden;
    overscroll-behavior-y: none;
    font-family: -apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, ubuntu, roboto, noto, segoe ui, arial, sans-serif;
    color: black;
    background: white;
  }
`;
